import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { HomeContent } from '../components/HomeContent/HomeContent';
import { Loading } from '../components/Loading';
import { TrackingPage } from '../components/TrackingPage';
import { forwarderConfig } from '../globals/ForwarderConfig';
import { TrackingModuleLayout } from '../layouts/TrackingModuleLayout';
import '../types';

/** @type {React.FC<{}>} */
const Track = () => {

    const router = useRouter();
    const { asPath, query } = router;
    const { id: trackingNumber = '' } = query;

    const [hideSearchBar, setHideSearchBar] = useState(true);

    const [loading, setLoading] = useState(true);

    const [data, setData] = useState(
        (/** @type {TrackingPageData} */({}))
    );
    const [status, setStatus] = useState(
        (/** @type {number | undefined} */(undefined))
    );

    const customerSuccessEmail = forwarderConfig[process.env.FORWARDER].customerSuccessEmail;

    useEffect(() => {
        function redirectToTheHomePage() {
            router.push('/');
        }

        if (asPath === '/track') {
            // no query params in the URL
            redirectToTheHomePage();
        }

        // on first render, query is an empty object
        if (Object.keys(query).length > 0) {
            if (trackingNumber) {
                (async () => {
                    // show loader on every page transition
                    setLoading(true);
                    setHideSearchBar(true);

                    const response = await fetch(`${process.env.NAVREST_PATH}/track/${trackingNumber}`);

                    if (response.status === 200) {
                        const dataJson = await response.json();
                        setData(dataJson);
                        setHideSearchBar(false);
                    }

                    setStatus(response.status);
                    setLoading(false);
                })();
            } else {
                // query parameters exist in the URL, but no id (trackingNumber)
                redirectToTheHomePage();
            }
        }
    }, [asPath, query, router, trackingNumber]);

    let content;

    if (loading) {
        content = <Loading />;
    } else {
        switch (status) {
            case 200:
                content = (
                    <TrackingPage
                        data={data}
                        trackingNumber={trackingNumber}
                    />
                );
                break;
            case 404:
                content = <HomeContent message={`Tracking number "${trackingNumber}" was not found.`} />;
                break;
            case 500:
                content = <HomeContent message='Your request failed. We’ve logged the error. Please try again later.' />;
                break;
            default:
                content = (
                    <HomeContent message={(
                        <>
                            Something is not working correctly. Please contact <a href={`mailto:${customerSuccessEmail}`}>Customer Success</a> if you continue to see this error.
                        </>
                    )}
                    />
                );
                break;
        }
    }

    return (
        <TrackingModuleLayout hideSearchBar={hideSearchBar}>
            {content}
        </TrackingModuleLayout>
    );
};

export default Track;
